import { addUniquenotEmptyElements } from "../../helpers";
var TopLeaguesRetriever = /** @class */ (function () {
    function TopLeaguesRetriever(bffGateway, dataProvider, loadedData) {
        this.bff = bffGateway;
        this.dataProvider = dataProvider;
        this.requestTopLeague = {};
        this.requestTopLeague.ids = [this.dataProvider.sportId];
        this.requestTopLeague.regionIds = addUniquenotEmptyElements(this.dataProvider.regionId || []);
        this.loadedData = loadedData;
    }
    TopLeaguesRetriever.prototype.setRegionIds = function (regionId) {
        this.requestTopLeague.regionIds = addUniquenotEmptyElements(this.dataProvider.regionId.concat(regionId));
    };
    TopLeaguesRetriever.prototype.removeRegionId = function () {
        this.requestTopLeague.regionIds = [this.dataProvider.regionId[0]];
    };
    TopLeaguesRetriever.prototype.loadData = function () {
        var _this = this;
        this.bff.getTopLeaguesBySportId(this.requestTopLeague)
            .then(function (response) { return _this.loadDataSuccessCb(response); })
            .catch(function (err) { console["log"](err); });
    };
    TopLeaguesRetriever.prototype.loadDataSuccessCb = function (response) {
        if (response.leagues && response.leagues.length) {
            this.loadedData(response.leagues);
        }
    };
    return TopLeaguesRetriever;
}());
export { TopLeaguesRetriever };
//# sourceMappingURL=TopLeaguesRetriever.js.map